import React from 'react';
import withStyles from '@mui/styles/withStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import * as utils from '../utils';

const styles = theme => ({
  root: {
    width: '100%',
  },
  table: {
    minWidth: 250,
  },
  tableHeader: {
    fontWeight: "bold",
  },
  firstRow: {
    backgroundColor: "#c0c0c0",
  }
});

function TyperFinanceSummary(props) {
  const { classes, summaryPerTyper, totals } = props;

  return <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="exames">
        <TableHead>
          <TableRow className={classes.firstRow}>
            <TableCell className={classes.tableHeader}>Digitadores</TableCell>
            <TableCell align="left" className={classes.tableHeader}>Exames</TableCell>
            <TableCell align="left" className={classes.tableHeader}>Total</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(summaryPerTyper).map((key) => (
            <TableRow key={key}>
              <TableCell>{summaryPerTyper[key].typer_name}</TableCell>
              <TableCell>{ summaryPerTyper[key].count }</TableCell>
              <TableCell>{ utils.formatBillValue(summaryPerTyper[key].typer_value) }</TableCell>
            </TableRow>
	  ))}
          <TableRow>
            <TableCell></TableCell>
            <TableCell align="left">{ totals.count }</TableCell>
            <TableCell align="left">{ utils.formatBillValue(totals.typer_value) }</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
}

export default withStyles(styles)(TyperFinanceSummary);